import { useIntl } from 'react-intl';

import { getRecordingExpirationDays, RecordingAsset, RecordingSettings } from '@kaltura-ott/tvpil-shared';

import { useWidgetContext } from 'context/widgetProvider/widgetProvider';

import { isStandaloneRecordingAsset } from '../../utils';

const translationId = 'Rail.RailCard';

export function useExpirationBadge(recording: RecordingAsset) {
  const intl = useIntl();

  const { settings } = useWidgetContext<RecordingAsset, RecordingSettings>();

  if (!settings.recordingExpirationBoundary || !isStandaloneRecordingAsset(recording)) {
    return undefined;
  }

  const expiredInDays = getRecordingExpirationDays(recording, settings.recordingExpirationBoundary);

  if (expiredInDays === undefined) {
    return undefined;
  }

  if (expiredInDays === 0) {
    return intl.formatMessage({ id: `${translationId}.expiresToday`, defaultMessage: 'EXPIRES TODAY' });
  }

  if (expiredInDays === 1) {
    return intl.formatMessage({ id: `${translationId}.expiresTomorrow`, defaultMessage: 'EXPIRES TOMORROW' });
  }

  return intl.formatMessage(
    {
      id: `${translationId}.expiresDays.${intl.formatPlural(expiredInDays)}`,
      defaultMessage: '{days, plural, one {EXPIRES IN 1 DAY} other {EXPIRES IN # DAYS}}',
    },
    { days: expiredInDays },
  );
}
